import {useContext, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";
import HostNameAndTldAndCurrencyCodeAndApiKeyList from "../IntegrationFormInput/HostNameAndTldAndCurrencyCodeAndApiKeyList.jsx";
import {ProjectIntegrationsApi} from "../../../../api/authority/generated/index";
import toast from "react-hot-toast";
import useAuthorityConfiguration from "../../../../api/utilities/useAuthorityConfiguration.js";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import {IntegrationActions, IntegrationSection} from "../IntegrationDetailUi.jsx";
import Button from "../../../../components/Button.jsx";

export default function GlamiIntegrationForm({project, projectIntegration}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();
    let {resetCurrentUserProjects} = useContext(GlobalContext);
    let navigate = useNavigate();

    let authorityConfiguration = useAuthorityConfiguration();

    let [glamiSettings, setGlamiSettings] = useState({
        hostNameAndTldAndApiCurrencyCodeApiKeyData: [],
    });
    let rows = glamiSettings.hostNameAndTldAndApiCurrencyCodeApiKeyData ?? [];
    let isSubmitDisabled = rows.length === 0 || rows.some((row) => {
        return !row.hostName || !row.tld || !row.currencyCode || (!row.apiKeyConfigured && !row.apiKey?.trim());
    });

    let createGlamiIntegration = () => {
        new ProjectIntegrationsApi(authorityConfiguration)
            .glamiIntegration({
                projectId: project.id,
                integrationId: projectIntegration?.id ?? null,
                glamiIntegrationInput: glamiSettings,
            })
            .then(glamiIntegrationData => {
                navigate(
                    '/project/' + project.id + '/settings/integrations?integrationId=' + glamiIntegrationData.id
                );
                resetCurrentUserProjects();
                toast.success(projectIntegration === null ? t('created') : t('saved'));
            })
            .catch(e => et(e).then((message) => { if (message) toast.error(message); }));
    };

    return (
        <IntegrationSection
            title={'Domény a API klíče'}
            description={'Pro každou doménu nastavte odpovídající zemi GLAMI, měnu a samostatný API klíč.'}
        >
            <HostNameAndTldAndCurrencyCodeAndApiKeyList
                project={project}
                projectIntegration={projectIntegration}
                value={glamiSettings.hostNameAndTldAndApiCurrencyCodeApiKeyData}
                apiKeySameForAll={false}
                onChange={(hostNameAndTldAndApiCurrencyCodeApiKeyData) => {
                    setGlamiSettings((glamiSettings) => {
                        return {
                            ...glamiSettings,
                            hostNameAndTldAndApiCurrencyCodeApiKeyData: hostNameAndTldAndApiCurrencyCodeApiKeyData,
                        };
                    });
                }}
            />

            <div className={'mt-5'}>
            <IntegrationActions hint={isSubmitDisabled ? 'Pro uložení vyplňte v každém boxu doménu, zemi, měnu i API klíč.' : null}>
                <Button
                    className={'button-primary'}
                    onClick={createGlamiIntegration}
                    title={projectIntegration ? 'Uložit změny' : 'Vytvořit integraci'}
                    disabled={isSubmitDisabled}
                >
                    {projectIntegration ? 'Uložit změny' : 'Vytvořit integraci'}
                </Button>
            </IntegrationActions>
            </div>
        </IntegrationSection>
    );
}
